import { FormType } from 'Container/App/enum';

export enum Title {
    MALE = 'Herr',
    FEMALE = 'Frau',
};

export enum LmsOpener {
    LANDING_PAGE,
    RESULT_SCREEN,
}

export interface LmsFormDTO {
    // form data
    salutation: Title | string,
    firstName: string,
    lastName: string,
    email: string,
    // address
    city: string,
    zipcode: string,
    district?: string,
    street: string,
    houseNumber: string,
    houseNumberExtra?: string | null,
    // other
    timestamp: string,
    referrer: string,
};

export interface LmsForm {
    type: FormType.LMS,
    salutation?: string,
    firstName?: string,
    lastName?: string,
    email?: string,
};

export interface LmsResponse {
    status: boolean,
    email?: boolean,
    firstName?: boolean,
    lastName?: boolean
}

export interface LmsFormState {
    lmsError?: Object,
    formData: LmsForm,
    responseData?: LmsResponse,
    openedBy: LmsOpener,
};
